import { compose, withHandlers, withStateHandlers } from 'recompose';
import { orderBy } from 'lodash/fp';

function withSort({ initialSortField = undefined, initialSortDescending = false } = {}) {
  return compose(
    withStateHandlers(
      {
        sortField: initialSortField,
        sortDescending: initialSortDescending
      },
      {
        onSort({ sortField, sortDescending }) {
          return (field, desc) => ({
            sortField: field,
            sortDescending: field === sortField && desc === undefined ? !sortDescending : !!desc
          });
        }
      }
    ),
    withHandlers({
      sortData({ sortField, sortDescending }) {
        const sortDirection = sortDescending ? 'desc' : 'asc';
        if (!sortField) {
          // default sort
          return orderBy(
            ['startTime', 'order', 'cost'],
            [sortDirection, sortDirection, sortDirection]
          );
        }
        return orderBy(sortField, sortDirection);
      }
    })
  );
}

export default withSort;
